module.exports = __webpack_public_path__ + "img/8.40742f11.png";